window.OestPurchaseForm = window.OestPurchaseForm || {
  findVisibleForm: function () {
    var wrappers = Array.from(document.querySelectorAll('[id^="product-purchase-form-"]'));

    for (var i = 0; i < wrappers.length; i++) {
      var forms = Array.from(wrappers[i].querySelectorAll('form.product-form'));
      var visibleForm = forms.find(function (form) {
        return form.offsetParent !== null;
      });

      if (visibleForm) return visibleForm;
    }

    return null;
  },
  submitVisibleForm: function () {
    var form = this.findVisibleForm();
    if (!form) return false;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }

    return true;
  },
  scrollToVisibleForm: function () {
    var form = this.findVisibleForm();
    if (!form) return false;

    var wrapper = form.closest('[id^="product-purchase-form-"]') || form;
    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });

    return true;
  },
};
